// Personal section icons mapped to authentic Windows XP icons
// to keep a consistent visual theme with the rest of the desktop.

import calculator32 from 'assets/windowsIcons/74(32x32).png';
import calculator16 from 'assets/windowsIcons/74(16x16).png';
import help32 from 'assets/windowsIcons/747(32x32).png';
import help16 from 'assets/windowsIcons/747(16x16).png';
import notepad32 from 'assets/windowsIcons/327(32x32).png';
import notepad16 from 'assets/windowsIcons/327(16x16).png';
import researchFolder32 from 'assets/windowsIcons/299(32x32).png';
import star32 from 'assets/windowsIcons/744(32x32).png';
import msn from 'assets/windowsIcons/msn.png';
import mail from 'assets/windowsIcons/mail.png';
import lightning from 'assets/windowsIcons/winamp.png';
import github32 from './github32.png';
import github16 from './github16.png';
import twitter32 from './twitter32.png';
import twitter16 from './twitter16.png';

// Angel Investments - calculator (finance)
export const investmentsFolderIcon32 = calculator32;
export const investmentsFolderIcon16 = calculator16;

// About Me - blue question mark (help)
export const bioFolderIcon32 = help32;
export const bioFolderIcon16 = help16;

// Writing - notepad
export const writingFolderIcon32 = notepad32;
export const writingFolderIcon16 = notepad16;

// Telegram - MSN messenger
export const telegramFolderIcon32 = msn;
export const telegramFolderIcon16 = msn;

// Email - envelope
export const emailFolderIcon32 = mail;
export const emailFolderIcon16 = mail;

// Airdrop - gold star (something special / freebie)
export const airdropFolderIcon32 = star32;
export const airdropFolderIcon16 = star32;

// Messari Research - magnifying glass (research/analysis)
export const messariFolderIcon32 = researchFolder32;
export const messariFolderIcon16 = researchFolder32;

// Vibecoded Projects - lightning bolt
export const vibecodedFolderIcon32 = lightning;
export const vibecodedFolderIcon16 = lightning;

// GitHub - octocat on an XP folder
export const githubFolderIcon32 = github32;
export const githubFolderIcon16 = github16;

// X (Twitter) - classic Twitter bird
export const twitterFolderIcon32 = twitter32;
export const twitterFolderIcon16 = twitter16;

// Legacy exports for backwards compatibility
export const investmentsFolderIcon = investmentsFolderIcon32;
export const bioFolderIcon = bioFolderIcon32;
export const writingFolderIcon = writingFolderIcon32;
export const articlesFolderIcon = writingFolderIcon32;
export const articlesFolderIcon32 = writingFolderIcon32;
export const articlesFolderIcon16 = writingFolderIcon16;
